module.exports = __webpack_public_path__ + "img/text-file.3e4a1eb2.svg";